import { Box } from '@mui/material';
import { AutoCompleteSelectUI, ButtonUI, DatePickerUI, FormLabelUI } from '../../Interface';
import { useEffect, useState } from 'react';
import masterDataService from '../../../service/masterData.service';
import { generateAutocompleteItems } from '../../../utils/helper';
import ProjectTable from './ProjectTable';
import AttendanceTable from './AttendanceTable';
import useMenus from '../../../context/MenuContext';
import useParam from '../../../context/ParamContext';

export const SettlementGeneratorPage = () => {
  const { getParam, params } = useParam();
  const { menus, getMenus, getMenuSubMenuId } = useMenus();
  const [autoCompleteOptions, setAutoCompleteOptions] = useState({
    company: [],
    status: [],
    resourceOne: [],
  });
  const [submenuId, setSubmenuId] = useState(null);

  const defFilter = {
    startDate: null,
    endDate: null,
    companyId: null,
  };
  const defAttendanceFilter = {
    statusId: null,
  };
  const [filter, setFilter] = useState(defFilter);
  const [attendanceFilter, setAttendanceFilter] = useState(defAttendanceFilter);
  const [checkedProjectIds, setCheckedProjectIds] = useState([]);

  useEffect(() => {
    getMenus();
    getParam();
  }, []);

  useEffect(() => {
    const submenuId = getMenuSubMenuId('attendance');
    setSubmenuId(submenuId);
  }, [menus]);

  useEffect(() => {
    if (submenuId) initDefaultValues();
  }, [submenuId]);

  const defStatusParam = params.ATTENDANCE_SETTLEMENT_GENERATOR_DEF_STATUS;
  const defStatus = Boolean(defStatusParam) ? parseInt(defStatusParam) : null;

  useEffect(() => {
    if (defStatus) {
      setAttendanceFilter((prev) => ({
        ...prev,
        statusId: defStatus,
      }));
    }
  }, [params]);

  const initDefaultValues = () => {
    const promiseArray = [];

    promiseArray.push(
      new Promise((resolve, reject) => {
        masterDataService
          .companyToForm()
          .then((data) => {
            resolve(data);
          })
          .catch((e) => {
            reject(e);
          });
      })
    );

    promiseArray.push(
      new Promise((resolve, reject) => {
        masterDataService
          .statusToForm(submenuId)
          .then((data) => {
            resolve(data);
          })
          .catch((e) => {
            reject(e);
          });
      })
    );

    promiseArray.push(
      new Promise((resolve, reject) => {
        masterDataService
          .resourceOneToForm()
          .then((data) => {
            resolve(data);
          })
          .catch((e) => {
            reject(e);
          });
      })
    );

    Promise.all(promiseArray).then((resp) => {
      const aData = {
        company: resp[0],
        status: resp[1],
        resourceOne: resp[2],
      };

      const acOptions = {
        company: generateAutocompleteItems(aData.company, 'name', 'id'),
        status: generateAutocompleteItems(aData.status.statusItems, 'itemName', 'itemId'),
        resourceOne: generateAutocompleteItems(aData.resourceOne, 'name', 'id'),
      };
      setAutoCompleteOptions(acOptions);
    });
  };

  const buildFilter = (baseState, items) => ({
    ...baseState,
    filter: {
      ...baseState.filter,
      filterModel: {
        ...baseState.filter.filterModel,
        items,
        logicOperator: 'and',
      },
    },
  });

  return (
    <Box px={2} py={1} backgroundColor="#E9F5FE">
      <Box display="flex" gap="2rem" flexWrap="wrap" alignItems="center">
        <Box width="250px">
          <DatePickerUI
            label={<FormLabelUI text="TÓL-" />}
            value={filter.startDate}
            onChange={(newDate) => {
              setFilter((prevState) => ({
                ...prevState,
                startDate: newDate ? newDate.startOf('day') : null,
              }));
            }}
          />
        </Box>
        <Box width="250px">
          <DatePickerUI
            label={<FormLabelUI text="-IG" />}
            value={filter.endDate}
            onChange={(newDate) => {
              setFilter((prevState) => ({
                ...prevState,
                endDate: newDate ? newDate.endOf('day') : null,
              }));
            }}
          />
        </Box>
        <Box width="250px">
          <AutoCompleteSelectUI
            label={<FormLabelUI text="Cég" />}
            selectedValue={filter.companyId}
            onChange={(_e, newVal, reason) => {
              if (reason === 'clear') {
                setFilter((prevState) => ({
                  ...prevState,
                  companyId: '',
                }));
              } else {
                setFilter((prevState) => ({
                  ...prevState,
                  companyId: newVal.value,
                }));
              }
            }}
            dataset={autoCompleteOptions.company}
          />
        </Box>
      </Box>
      <Box mt={3}>
        <ProjectTable
          filter={filter}
          setCheckedProjectIds={setCheckedProjectIds}
          checkedProjectState={{ checkedProjectIds, setCheckedProjectIds }}
          buildFilter={buildFilter}
        />
      </Box>
      <Box>
        <Box width="250px" my={1.5}>
          <AutoCompleteSelectUI
            label={<FormLabelUI text="Státusz" />}
            selectedValue={autoCompleteOptions.status.length > 0 && attendanceFilter.statusId}
            selectedLabelValue={
              autoCompleteOptions.status.find((item) => item.value === attendanceFilter.statusId)?.label
            }
            onChange={(_e, newVal, reason) => {
              if (reason === 'clear') {
                setAttendanceFilter((prevState) => ({
                  ...prevState,
                  statusId: '',
                }));
              } else {
                setAttendanceFilter((prevState) => ({
                  ...prevState,
                  statusId: newVal.value,
                }));
              }
            }}
            dataset={autoCompleteOptions.status}
          />
        </Box>
        <AttendanceTable
          checkedProjectState={{ checkedProjectIds, setCheckedProjectIds }}
          filter={filter}
          autoCompleteOptions={autoCompleteOptions}
          attendanceFilter={attendanceFilter}
          buildFilter={buildFilter}
        />
      </Box>
    </Box>
  );
};
